export type Zoom = {
  isZoomed: boolean;
  isIntermediateZoom: boolean;
  isElevatedZoom: boolean;
};

export const zoom: Zoom = {
  isZoomed: false,
  isIntermediateZoom: false,
  isElevatedZoom: false,
};

declare module '@mui/material/styles' {
  interface Theme {
    zoom: Zoom;
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    zoom: Zoom;
  }
}
